
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowShowersDayColour as ObiLightningLightSnowShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-showers-day-colour.js';
 
 
 

 
 export const ObiLightningLightSnowShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-showers-day-colour',
   elementClass: ObiLightningLightSnowShowersDayColourElement,
   events: {
     
   }
  });
 
 